var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 75,
  height: 79,
  viewBox: "0 0 75 79",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.95 62.618a32.127 32.127 0 01-16.157 4.338C14.682 66.956 0 51.967 0 33.478 0 14.988 14.682 0 32.793 0c18.111 0 32.793 14.989 32.793 33.478 0 7.259-2.263 13.978-6.108 19.463l13.45 13.731c2.763 2.82 2.763 7.393 0 10.213a6.972 6.972 0 01-10.004 0l-.002-.003-13.973-14.264zm6.794-29.454c0 12.854-10.206 23.274-22.797 23.274-12.59 0-22.798-10.42-22.798-23.274C10.15 20.31 20.356 9.89 32.947 9.89c12.59 0 22.797 10.42 22.797 23.274z",
  fill: "currentColor"
})));

export default SvgSearch;